import { SAME_DAY } from "@/config/app-constant";

import { useTravelDatesContext } from "../../providers/travel-dates.provider";
import { isSameDay } from "../../utils/date-picker.utils";
import { startDateValidationAMT } from "../../utils/date-validations.utils";

export function useDateSelectionAMT() {
  const context = useTravelDatesContext();
  const {
    groupedMagnoliaData,
    isModalOpen,
    keyForGroupedMagnolia,
    maxDateforAMT,
    modalType,
    setCancelBtnClick,
    setIsDateError,
    setIsModalOpen,
    setModalType,
    setPendingDate,
    setTravelDates,
    setTravelDateErrorMessage,
    setError,
  } = context;

  const { errorMessage } = groupedMagnoliaData?.[keyForGroupedMagnolia] ?? {};

  const handleDateSelectionAMT = (date: Date) => {
    const currentDate = new Date();
    setModalType(null);
    setCancelBtnClick(false);

    setTravelDates({
      validate: false,
      startDate: date ?? null,
      endDate: date ?? null,
    });

    if (
      !startDateValidationAMT({
        date,
        errorMessage,
        maxDateforAMT,
        setError,
      })
    ) {
      return;
    }

    // Same day selection
    if (isSameDay(date, currentDate)) {
      setIsDateError(false);
      setTravelDateErrorMessage("");
      setPendingDate(date);
      setModalType(SAME_DAY);
      setIsModalOpen(true);
      return;
    }

    // Valid selection
    setIsDateError(false);
    setTravelDateErrorMessage("");
    setTravelDates({
      validate: true,
      startDate: date,
      endDate: date,
    });
    if (modalType === SAME_DAY && isModalOpen) {
      setIsModalOpen(false);
    }
  };

  return { handleDateSelectionAMT };
}
